import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n'
import messages from './translations';

export const bus = new Vue({});

Vue.config.productionTip = false

Vue.use(VueI18n);

/**
 * init i18n translation object
 * @type {VueI18n}
 */
 const i18n = new VueI18n({
  fallbackLocale: 'en-us',
  locale: 'en-us', // set locale
  messages // set locale messages
})

const filter = function(text, length, clamp){
  clamp = clamp || '...';
  var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', filter);

new Vue({
  i18n,
  render: h => h(App),
}).$mount('#resource_library_app')